<template>
<div>
  <div class="search-wrap">
    <el-button size="mini" @click="openApportionTemplateWin()">创建模板</el-button>
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
    <el-button size="mini" @click="deleteApportionTemplate()">删除</el-button>
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="模版名称">
        <el-input size="mini" placeholder="请输入模板名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange" >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="id" width="80"></el-table-column>
      <el-table-column prop="name" label="仪表名称 " width="200"></el-table-column>
      <el-table-column label="分摊模式" width="100">
        <template slot-scope="scope">
          {{scope.row.apportion_type}}
        </template>
      </el-table-column>
      <el-table-column prop="customer_count" label="分摊人数"  width="100"></el-table-column>
      <el-table-column prop="create_time" label="创建时间 "  width="140"></el-table-column>

      <el-table-column prop="update_time" label="修改时间" width="140"></el-table-column>

      <el-table-column label="操作 ">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openApportionTemplateWin(scope.row.id,scope.row.name)">编辑</el-button>
          <el-button type="primary" size="mini" @click="copyApportionTemplateWin(scope.row)">复制到仪表</el-button>
          <el-button type="danger" size="mini" @click="multipleSelection.push(scope.row);deleteApportionTemplate()">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
    <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>
  <ApportionTemplateWin ref="ApportionTemplateWinRef" />
  <SelectMeterTree ref="SelectMeterTreeRef" />
</div>
</template>

<script>
import {Loading} from "element-ui";
import ApportionTemplateWin from "./components/ApportionTemplateWin";
import SelectMeterTree from "./components/SelectMeterTree";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "ApportionTemplateList",
  inject:['mainObj','componentId','setComponentId'],
  components:{SelectMeterTree, ApportionTemplateWin},
  data(){
    return{
      where:{
        name:"",
      },
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
    }
  },
  mounted() {
    this.mainObj.project_id&&this.pageChange(1);
  },
  methods:{
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterApportionTemplate/getList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    openApportionTemplateWin(id=0,name=''){
      const that=this;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目')
        return false;
      }
      that.$refs.ApportionTemplateWinRef.show({id:id,name:name})
    },
    copyApportionTemplateWin(item){
      const that=this;
      that.$refs.SelectMeterTreeRef.show({
        title:"",
        project_id:that.mainObj.project_id,
        isCheckbox:true,
      },meter_list=>{
        //children_count
        meter_list=meter_list.filter(ret=>(ret.check_Child_State===ret.children_count||ret.check_Child_State===-1))
        if(meter_list.length>0){
          let text=`此操作将设置 ${meter_list.length} 个仪表的分摊对象配置, 是否继续?`;
          that.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let meter_ids=meter_list.map(ret=>ret.id);
            that.setMeterApportion(item.id,meter_ids);
          });
        }else {
          that.$message.error('请选择仪表')
        }
      });
    },
    setMeterApportion(template_id=0,meter_ids=[]){
      const that = this;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterApportionTemplate/setMeterApportion",{
        project_id:that.mainObj.project_id,
        template_id:template_id,
        meter_ids:JSON.stringify(meter_ids),
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          that.$message.success('设置成功')
        }else {
          that.$message.error(res.msg||'设置失败')
        }
      })
    },
    deleteApportionTemplate(){
      const that=this;
      let ids=that.multipleSelection.map(ret=>ret.id);
      if(ids.length>0){
        let text=`此操作将删除 ${ids.length} 个模板, 是否继续?`;
        that.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          MeterHttp.post("MeterApportionTemplate/deleteApportionTemplate",{
            ids:JSON.stringify(ids),
            user_type:(that.$route.query.type||0),
          }, res => {
            if (res.code) {
              that.$message.success('删除成功')
              that.pageChange(1)
            }else {
              that.$message.error(res.msg||'删除失败')
            }
          })
        }).catch(() => {
          that.$message.info('已取消删除操作')
        });
      }else {
        that.$message.error('请选择模板')
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  watch:{
    "mainObj.house_name":(newVal,oldVal)=>{
      if(newVal!==oldVal){
        this.pageChange(1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/apportion_template/ApportionTemplateList.vue